import { WIDGET_NAME } from '../constants';

export const isBetaV2Widget = (widgetName: WIDGET_NAME) =>
    [WIDGET_NAME.BETA_REGISTRATION_V2, WIDGET_NAME.BETA_APPROVAL_V2, WIDGET_NAME.BETA_GUARANTEED_ACCESS_V2].includes(widgetName);

export const isBetaRegistrationV2Widget = (widgetName: WIDGET_NAME) =>
    widgetName === WIDGET_NAME.BETA_REGISTRATION_V2;
export const isBetaApprovalV2Widget = (widgetName: WIDGET_NAME) =>
    widgetName === WIDGET_NAME.BETA_APPROVAL_V2;

export const isBetaApprovalWidget = (widgetName: WIDGET_NAME) =>
    widgetName === WIDGET_NAME.BETA_APPROVAL;

export const isBetaGuaranteedAccessV2Widget = (widgetName: WIDGET_NAME) =>
    widgetName === WIDGET_NAME.BETA_GUARANTEED_ACCESS_V2;

export const isBetaRegistrationWidget = (widgetName: WIDGET_NAME) =>
    widgetName === WIDGET_NAME.BETA_REGISTRATION;

export const isRedeemV2Widget = (widgetName: WIDGET_NAME) =>
    widgetName === WIDGET_NAME.CF_REDEEM_V2;

export const isPYCRedeemV2Widget = (widgetName: WIDGET_NAME) =>
    widgetName === WIDGET_NAME.PYC_REDEEM_V2;

export const isVersionV2 = (widgetName: WIDGET_NAME) => {
    return isBetaV2Widget(widgetName) || isPYCRedeemV2Widget(widgetName);
}
